import { render, staticRenderFns } from "./SafirDevices.vue?vue&type=template&id=7483150b&"
import script from "./SafirDevices.vue?vue&type=script&lang=js&"
export * from "./SafirDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports